import type { MergeTuning } from "@slot/mechanics-merge";
import type { CellMultiplierBadgeTuning } from "../features/cell-multipliers/CellMultiplierView";

// The merge's VALUES — the only file to edit to retune it: the consumed candies flying into their target, the target's
// pop into the next symbol, the badges landing on the winning cells after it and colouring their tiles. The shapes are
// the merge mechanic's and the badge view's.

export const MERGE_TUNING: MergeTuning = {
  flySeconds: 0.26,
  flyEasing: "quadIn",
  consumedEndScale: 0.55,
  // Every output's candies fly at once, the merge's clusters together (user, 2026-10-10).
  outputStaggerSeconds: 0,
  popSeconds: 0.32,
  popScale: 1.3,
  postMergeHoldSeconds: 0.08,
};

/**
 * A badge at its cell's lower right, as the layout example draws "x64": the glyphs' frames 44 units tall (a digit's white
 * 30 of it), the last digit's white edge 75 right of the cell's centre and its frame's centre line 48 below.
 */
export const CELL_MULTIPLIER_BADGE_TUNING: CellMultiplierBadgeTuning = {
  offsetX: 73.5,
  offsetY: 48,
  boxWidth: 132,
  boxHeight: 44,
  popSeconds: 0.3,
  popScale: 1.35,
  // A badged cell's tile warms with its value: x2 yellow, x3 amber, x4 orange, x5 coral, x6 and up candy pink — the
  // badge digits' warm range, so the board reads its hot cells at a glance; stronger than the plain tile's 0.32.
  tile: { colors: [0xffd23f, 0xffa938, 0xff8436, 0xff5f57, 0xff4a8a], alpha: 0.8, fadeSeconds: 0.25 },
};
